window.Products.Clothing.ComfortRacerbackTankTop = function() {
};
window.Products.Clothing.ComfortRacerbackTankTop.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ComfortRacerbackTankTop.dpi = 150;
window.Products.Clothing.ComfortRacerbackTankTop.has_3d = true;
window.Products.Clothing.ComfortRacerbackTankTop.id = 106;
window.Products.Clothing.ComfortRacerbackTankTop.slug = 'comfort-racerback-tank-top';
window.Products.Clothing.ComfortRacerbackTankTop.syncColors = true;
window.Products.Clothing.ComfortRacerbackTankTop.texturesLoaded = 0;
window.Products.Clothing.ComfortRacerbackTankTop.texturesLoading = false;
window.Products.Clothing.ComfortRacerbackTankTop.use_glb = true;

window.Products.Clothing.ComfortRacerbackTankTop.prototype.outsideObject = 0;
window.Products.Clothing.ComfortRacerbackTankTop.prototype.detailsObject = 1;
window.Products.Clothing.ComfortRacerbackTankTop.prototype.position = 0.1;

window.Products.Clothing.ComfortRacerbackTankTop.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather")){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = 0.1;
};

window.Products.Clothing.ComfortRacerbackTankTop.prototype.getColor = function(_name){
	colors = {
		"heather_charcoal": 0x505050,
		"black": 0x171616,
		"heather_fuchsia": 0xe85371,
		"heather_graphite": 0x332f2c,
		"heather_grey": 0x797979,
		"heather_purple": 0x685575,
		"heather_red": 0xcf4c52,
	};

	return new THREE.Color(colors[_name]);
};